var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgActionItalic = function SvgActionItalic(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Italic"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.42931 15.9375C5.95273 15.9375 5.625 15.6494 5.625 15.1812C5.625 14.7226 5.94432 14.4441 6.42091 14.4441H8.10996L10.0223 5.55588H8.34045C7.86507 5.55588 7.53614 5.26897 7.53614 4.80079C7.53614 4.34101 7.85666 4.0625 8.33205 4.0625H13.5925C14.0691 4.0625 14.3884 4.34101 14.3884 4.80079C14.3884 5.26897 14.0607 5.55708 13.5841 5.55708H11.9106L9.98989 14.4441H11.6813C12.1567 14.4441 12.4773 14.7226 12.4773 15.1824C12.4773 15.6506 12.1483 15.9375 11.6729 15.9375H6.42931Z",
    fill: "white"
  }))));
};
export default SvgActionItalic;